import { _requireAccessLevelAndLocation, redirectBusinessRoute, requireAuthAndLocation } from '../auth'
import { conversationAIRouteNames, locationSettingsRouteNames, opportunitiesRouteNames, voiceAIRouteNames } from '@/routes/constants/location'
import { knowledgeBaseRouteNames, reputationRouteNames } from '../constants/location'

import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { routePaths } from '../paths'

const EmptyRouterParent = () => import('@/pmd/pages/EmptyRouterParent.vue').then(m => m.default)

const CompanySettingsPage = () =>
  import(/* webpackChunkName: "location-company-settings" */ '@/pmd/pages/settings/CompanySettingsPage.vue').then(
    m => m.default
  )

const LocationBillingPage = () =>
  import(/* webpackChunkName: "location-company-settings" */ '@/pmd/pages/LocationBilling.vue').then(
    m => m.default
  )

const LocationBilling = () =>
  import(/* webpackChunkName: "location-company-settings" */ '@/pmd/pages/settings/LocationBillingPage.vue').then(
    m => m.default
  )


const LocationBillingSettings = () => import('@/pmd/pages/settings/LocationBillingSettings.vue').then(m => m.default)

const LocationWalletTransactions = () =>
  import('@/pmd/pages/settings/LocationWalletTransactions.vue').then(m => m.default)

const AccountTeamsManagement = () =>
  import(/* webpackChunkName: "team-management" */ '@/pmd/pages/agency/AccountTeamsManagement.vue').then(m => m.default)

const Team = () => import('@/pmd/pages/agency/Team.vue').then(m => m.default)

const AutomationSettingsPage = () =>
  import(/* webpackChunkName: "location-custom-values" */ '@/pmd/pages/settings/AutomationSettingsMicroApp.vue').then(
    m => m.default
  )

const NewCalendarSetupPage = () =>
  import(/* webpackChunkName: "calendar-setup" */ '@/pmd/pages/settings/NewCalendarSetupPage.vue').then(
    m => m.default
  )

const ServiceSettings = () =>
    import(/* webpackChunkName: "service-settings" */ '@/pmd/pages/calendars/services/ServiceSettings.vue').then(
      m => m.default
    )

const CalendarConnections = () =>
    import(/* webpackChunkName: "calendar-connections" */ '@/pmd/pages/calendars/CalendarConnections.vue').then(
      m => m.default
    )

const ConversationAiSettings = () =>
  import(/* webpackChunkName: "profile-settings" */ '@/apps/conversations/settings/ai.vue')

const ConversationAiSettingsV2 = () =>
  import(/* webpackChunkName: "profile-settings" */ '@/apps/conversations/settings/aiV2.vue')


const VoiceAiSettings = () => import(/* webpackChunkName: "profile-settings" */ '@/apps/voice/settings/ai.vue')

const AllPhoneNumbersSettings = () =>
  import(
    /* webpackChunkName: "location-phone-number-settings" */ '@/pmd/pages/settings/AllPhoneNumbersSettings.vue'
  ).then(m => m.default)

const WhatsApp = () => import(/* webpackChunkName: "whatsapp" */ '@/pmd/pages/settings/WhatsAppSettings.vue')

const ISVApp = () => import('@/pmd/pages/isv/ISVApp.vue')

const CustomFieldsRouter = () =>
  import(
    /* webpackChunkName: "custom-fields-settings" */ '@/apps/custom-fields/CustomFieldsRouter.vue'
  ).then(m => m.default)

const CustomValues = () =>
    import(
      /* webpackChunkName: "location-custom-values" */ '@/pmd/pages/settings/CustomValues.vue'
    ).then(m => m.default)

const ScoringRouter = () =>
      import(
        /* webpackChunkName: "custom-fields-settings" */ '@/apps/manage-scoring/ManageScoringRouter.vue'
      ).then(m => m.default)

const DomainSettings = () =>
        import(
          /* webpackChunkName: "domain-settings" */ '@/pmd/pages/settings/DomainSettings.vue'
        ).then(m => m.default)

const RedirectSettings = () =>
          import('@/pmd/pages/settings/RedirectSettings.vue').then(m => m.default)

const ConversationProviderSettings  = () =>
          import('@/pmd/pages/settings/ConversationProviderSettings.vue').then(m => m.default)

const ExternalTrackingSettings = () =>
          import('@/pmd/pages/settings/ExternalTrackingSettings.vue').then(m => m.default)

const TagsSettings = () =>
  import(
    /* webpackChunkName: "tags-settings" */ '@/pmd/pages/settings/manage_tags/TagsSettings.vue'
  ).then(m => m.default)

const GhlLabs = () =>
    import(
      /* webpackChunkName: "domain-settings" */ '@/pmd/pages/settings/GhlLabs/GhlLabs.vue'
    ).then(m => m.default)

const AuditLogs = () => import('@/pmd/pages/audit/AuditLogs.vue')

const PipelineSettings = () =>
  import(
    /* webpackChunkName: "location-pipeline-settings" */ '@/pmd/pages/settings/PipelineSettings.vue'
  ).then(m => m.default)

const IntegrationSettingsPage = () =>
    import(
      /* webpackChunkName: "location-integration-settings" */ '@/pmd/pages/settings/IntegrationSettingsPage.vue'
    )

const FacebookAdFieldsMappingSettings = () =>
      import(
        /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/settings/FacebookAdFieldsMappingSettings.vue'
      )

const TikTokAdFieldsMappingSettings = () =>
        import(
          /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/TikTokAdFieldsMappingSettings.vue'
        )

const LinkedInFormsPage = () =>
          import(
            /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/linkedIn/LinkedInFormsPage.vue'
          )

const FacebookFormsPage = () =>
            import(
              /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/facebook/FacebookFormsPage.vue'
            )

const PrivateIntegration = ()=> import('@/pmd/pages/settings/PrivateIntegration.vue').then(m => m.default)

const BulkActionsOpportunityPage = () =>
  import(
    /* webpackChunkName: "customer-imports" */ '@/pmd/pages/bulk-actions/BulkActionsOpportunityPage.vue'
  )

const SmartList = () =>
  import(
    /* webpackChunkName: "smartlist" */ '@/pmd/pages/smartlist/SmartList.vue'
  ).then(m => m.default)

const BusinessSettings = () =>
  import(
    /* webpackChunkName: "business-settings" */ '@/pmd/pages/settings/BusinessSettings.vue'
  ).then(m => m.default)

const CustomEmailsSettings = () =>
  import(
      /* webpackChunkName: "tags-settings" */ '@/pmd/pages/settings/CustomEmailsSettings.vue'
  ).then(m => m.default)

const KnowledgeBaseSettings = () =>
    import(/* webpackChunkName: "profile-settings" */ '@/apps/conversations/settings/knowledgeBase.vue')

const GMBPagesV2 = () =>
  import(
    '@/pmd/pages/integrations/gmb/GMBPagesV2.vue'
  )
const LcIntegrationPage = () =>
  import(
    '@/pmd/pages/integrations/lcIntegrations/LcIntegrationPage.vue'
  )

export const locationSettingsRoute: RouteConfig[] = [
  {
    path: 'company',
    name: locationSettingsRouteNames.company,
    component: CompanySettingsPage,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'company-billing',
    name: locationSettingsRouteNames.locationBilling.default,
    beforeEnter: requireAuthAndLocation,
    component: LocationBillingPage,
    children: [
      {
        path: 'billing',
        name: locationSettingsRouteNames.locationBilling.default,
        component: LocationBillingPage,
      },
      {
        path: 'transactions',
        name: locationSettingsRouteNames.locationBilling.default,
        component: LocationBillingPage,
      },
    ],
  },
  {
    path: 'staff',
    name: locationSettingsRouteNames.staff.default,
    component: EmptyRouterParent,
    beforeEnter: _requireAccessLevelAndLocation,
    children: [
      {
        path: 'teams',
        name: locationSettingsRouteNames.staff.teams,
        component: AccountTeamsManagement,
        beforeEnter: _requireAccessLevelAndLocation,
        meta: { translations: [Modules.BusinessSettings] },
      },
      {
        path: 'team',
        name: locationSettingsRouteNames.staff.team,
        component: Team,
        beforeEnter: _requireAccessLevelAndLocation,
      },
    ],
  },
  {
    path: 'automation',
    component: AutomationSettingsPage,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '/',
        name: locationSettingsRouteNames.automation,
        component: AutomationSettingsPage,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'calendars',
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '/',
        name: locationSettingsRouteNames.calendars.default,
        component: NewCalendarSetupPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'preferences',
        name: locationSettingsRouteNames.calendars.preferences,
        component: NewCalendarSetupPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'availability',
        name: locationSettingsRouteNames.calendars.availability,
        component: NewCalendarSetupPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'connections',
        name: locationSettingsRouteNames.calendars.connections,
        component: NewCalendarSetupPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'services',
        name: locationSettingsRouteNames.calendars.services,
        component: ServiceSettings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'connections-new',
        name: locationSettingsRouteNames.calendars.newConnections,
        component: CalendarConnections,
        beforeEnter: requireAuthAndLocation,
      }
    ],
  },
  {
    path: 'conversation-ai',
    name: conversationAIRouteNames.conversationAISettings,
    component: ConversationAiSettings,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '/',
        component: ConversationAiSettings,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'conversation-ai-v2',
    name: conversationAIRouteNames.conversationAISettingsV2,
    component: ConversationAiSettingsV2,
    // component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'ai-agents',
    name: voiceAIRouteNames.aiAgentSettings,
    component: VoiceAiSettings,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '/',
        name: voiceAIRouteNames.aiAgentSettingsDefault,
        component: VoiceAiSettings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':agentId',
        name: voiceAIRouteNames.aiAgentSettingsEditAgent,
        component: VoiceAiSettings,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'phone_number',
    name: locationSettingsRouteNames.phoneNumber,
    component: AllPhoneNumbersSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'whatsapp',
    name: locationSettingsRouteNames.whatsapp,
    component: WhatsApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: routePaths.smtpServices,
    name: locationSettingsRouteNames.emailService.default,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.emailServicesDedicatedDomains,
    name: locationSettingsRouteNames.emailService.dedicatedDomains.default,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.emailServicesAddDomain,
    name: locationSettingsRouteNames.emailService.dedicatedDomains.addDomain,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.emailServicesSmtpSettings,
    name: locationSettingsRouteNames.emailService.dedicatedDomains.domainSettings,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.emailServicesVerifyDomain,
    name: locationSettingsRouteNames.emailService.dedicatedDomains.verifyDomain,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.blacklistMonitorReports,
    name: locationSettingsRouteNames.emailService.blacklistMonitorReports,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.emailServicesOPMTrafficStats,
    name: locationSettingsRouteNames.emailService.postmasterTools.opmTrafficStats,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: routePaths.emailServicesGPMTrafficStats,
    name: locationSettingsRouteNames.emailService.postmasterTools.gpmTrafficStats,
    beforeEnter: requireAuthAndLocation,
    component: ISVApp,
  },
  {
    path: 'reputation/settings',
    name: locationSettingsRouteNames.reputation,
    redirect: { name: reputationRouteNames.settings },
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'fields',
    name: locationSettingsRouteNames.fields,
    component: CustomFieldsRouter,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.CustomField] },
  },
  {
    path: 'custom_values',
    name: locationSettingsRouteNames.customValues,
    component: CustomValues,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'scoring',
    name: locationSettingsRouteNames.scoring,
    component: ScoringRouter,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'domain',
    name: locationSettingsRouteNames.domain,
    component: DomainSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'redirect',
    name: locationSettingsRouteNames.URLRedirect,
    component: RedirectSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'external-tracking',
    name: locationSettingsRouteNames.externalTracking,
    component: ExternalTrackingSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'conversation_providers',
    name: locationSettingsRouteNames.conversationProviders,
    component: ConversationProviderSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'tags',
    name: locationSettingsRouteNames.tags,
    component: TagsSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'labs',
    name: locationSettingsRouteNames.labs,
    component: GhlLabs,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'audit/logs',
    name: locationSettingsRouteNames.auditLogs,
    component: AuditLogs,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'private-integrations',
    name: locationSettingsRouteNames.privateIntegrations.default,
    component: PrivateIntegration,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '',
        name: locationSettingsRouteNames.privateIntegrations.list,
        component: PrivateIntegration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':appId',
        name: locationSettingsRouteNames.privateIntegrations.appId,
        component: PrivateIntegration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':appId/edit',
        name: locationSettingsRouteNames.privateIntegrations.appIdEdit,
        component: PrivateIntegration,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'integrations',
    name: locationSettingsRouteNames.integrations.default,
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'list',
        name: locationSettingsRouteNames.integrations.list,
        component: IntegrationSettingsPage,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.BusinessSettings] },
      },
      {
        path: 'facebook',
        name: locationSettingsRouteNames.integrations.facebook,
        component: FacebookAdFieldsMappingSettings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'tiktok',
        name: locationSettingsRouteNames.integrations.tiktok,
        component: TikTokAdFieldsMappingSettings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'linkedin',
        name: locationSettingsRouteNames.integrations.linkedIn,
        component: LinkedInFormsPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'facebook-forms',
        name: locationSettingsRouteNames.integrations.facebookForms,
        component: FacebookFormsPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'gbp',
        name: locationSettingsRouteNames.integrations.gbpPages,
        component: GMBPagesV2,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'lc-integrations',
    name: locationSettingsRouteNames.lcIntegrations.default,
    component: LcIntegrationPage,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'pipeline',
    name: locationSettingsRouteNames.pipeline,
    component: PipelineSettings,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.PipelineSettings] },
  },
  {
    path: 'bulk-actions',
    name: opportunitiesRouteNames.BulkActions,
    component: BulkActionsOpportunityPage,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'smart_list/Settings',
    name: locationSettingsRouteNames.smartList,
    component: SmartList,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.SmartList] },
  },
  {
    path: 'businesses',
    name: locationSettingsRouteNames.business,
    component: BusinessSettings,
    beforeEnter: redirectBusinessRoute,
    meta: { translations: [Modules.BusinessSettings] },
  },
  {
    path: 'custom_emails',
    name: locationSettingsRouteNames.customEmails,
    component: CustomEmailsSettings,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'knowledge-base-settings',
    name: knowledgeBaseRouteNames.knowledgeBaseSettings,
    component: KnowledgeBaseSettings,
    beforeEnter: requireAuthAndLocation,
  },
  // Added for backward compatibility. To be removed after 2025-09-30
  {
    path: 'knowledge-base',
    redirect: '../ai-agents/knowledge-base',
  },
  {
    path: 'knowledge-base/:knowledgeBaseId',
    redirect: to => `../ai-agents/knowledge-base/${to.params.knowledgeBaseId}`,
  },
  {
    path: 'knowledge-base-listing',
    redirect: '../ai-agents/knowledge-base',
  },
  {
    path: 'knowledge-base-listing/knowledgeBase/:knowledgeBaseId',
    redirect: to => `../ai-agents/knowledge-base/${to.params.knowledgeBaseId}`,
  },
]
